import { Typography } from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import { Divider, Grid, Tooltip } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ThemeContext } from "../../theme/ThemeContext";
import ViewIcon from "../Invitations/ViewIcon";

function PurposeTypeView({ heading, description, children, ...props }) {
  const [open, setOpen] = React.useState(false);
  const { t } = useTranslation();
  const { darkMode, setDiaLogBoxBlur } = useContext(ThemeContext);
  const handleClickOpen = () => {
    setOpen(true);
    setDiaLogBoxBlur(true);
  };
  const handleClose = () => {
    setOpen(false);
    setDiaLogBoxBlur(false);
  };
  useEffect(() => { }, []);

  return (
    <>
      <Grid onClick={handleClickOpen}>
        <ViewIcon darkMode={darkMode} />
      </Grid>

      <Dialog
        open={open}
        fullWidth={true}
        PaperProps={{
          style: {
            borderRadius: "20px !important",
            minWidth: "40vw",
            backgroundColor: darkMode ? "rgb(14, 42, 65)" : "#fff",
            color: darkMode ? "#fff" : "#434547",
          },
        }}
        disableBackdropClick
        disableEscapeKeyDown
        BackdropProps={{
          style: {
            backdropFilter: "blur(5px)",
          },
        }}
      >
        <DialogTitle variant="h4">
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 15,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon onClick={handleClose} />
          </IconButton>
          <Typography
            style={{
              color: darkMode ? "#fff" : "black",
              fontSize: "20px",
              fontWeight: "450",
            }}
          >
            {props.title}
          </Typography>
        </DialogTitle>
        <Divider
          variant="middle"
          style={{
            background: darkMode
              ? "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box"
              : "transparent linear-gradient(90deg, rgba(190, 231, 255, 0.05) 0%, rgba(34, 107, 171, 0.5) 47%, rgba(190, 231, 255, 0.05) 100%) 0% 0% no-repeat padding-box",
            height: "1px",
            opacity: 0.5,
          }}
        />
        <DialogContent>
          <Grid container spacing={2} style={{ alignItems: 'center' }}>
            <React.Fragment>
              <Grid item xs={3}>
                <Typography variant="body1" style={{ textTransform: 'capitalize' }}>
                  {t("Purpose")}
                </Typography>
              </Grid>
              <Grid item xs={.5} style={{ textAlign: 'center' }}>
                :
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1">{props.rowData.name}</Typography>
              </Grid>

              <Grid item xs={3}>
                <Typography variant="body1" style={{ textTransform: 'capitalize' }}>
                  {t("VISTYPE002")}
                </Typography>
              </Grid>
              <Grid item xs={.5} style={{ textAlign: 'center' }}>
                :
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1">
                  {props.rowData.templateId !== null
                    ? props.rowData.templateId.name
                    : ""}
                </Typography>
              </Grid>

              <Grid item xs={3}>
                <Typography variant="body1" style={{ textTransform: 'capitalize' }}>
                  {t("ATYPE009")}
                </Typography>
              </Grid>
              <Grid item xs={.5} style={{ textAlign: 'center' }}>
                :
              </Grid>
              <Grid item xs={6}>
                <Tooltip title={props.rowData.description}>
                  <Typography variant="body1"
                    style={{
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {props.rowData.description}
                  </Typography>
                </Tooltip>
              </Grid>
            </React.Fragment>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default PurposeTypeView;
